// extracted by mini-css-extract-plugin
module.exports = {"loaderButtonWrapper":"LoaderButton_loaderButtonWrapper__I0xlZ","loaderButton":"LoaderButton_loaderButton__bzcof"};